export const PAGE_HEADER_TABS_LABEL = "Abas da página";
